export function createFilterToExcludeExisting(collection: { uid: string }[]): (element: { uid: string }) => boolean {
    const uids = collection.map(element => element.uid);
    return (element: { uid: string }): boolean => {
        return uids.indexOf(element.uid) < 0;
    };
}
